import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Link } from '#/renderer/router';
import { isMobile } from 'react-device-detect';
import Collapsible from 'react-collapsible';
import $ from 'jquery';
// import _ from 'lodash-es';

import { ESPOTS } from '~/store/States/global';
import useStores from '~/store/StoreHook';
import SearchBox from '~/components/searchBox/SearchBox.ui';

function openMenu() {
  const wm = $('.wrapMenu');
  wm.show();
  wm.addClass('flex-display');
  $('.nav').children(':not(.wrapMenu)').addClass('blur-content');
  $('.catalog--header').children(':not(.wrapMenu)').addClass('blur-content');
  $('.catalog--module').children(':not(.wrapMenu)').addClass('blur-content');
}

function closeMenu() {
  const wm = $('.wrapMenu');
  wm.hide();
  wm.removeClass('flex-display');
  $('.nav').children(':not(.wrapMenu)').removeClass('blur-content');
  $('.catalog--header').children(':not(.wrapMenu)').removeClass('blur-content');
  $('.catalog--module').children(':not(.wrapMenu)').removeClass('blur-content');
}

function openNav() {
  //console.log('opeNav');
  document.getElementById('mySidenav').style.display = 'block';
}

function closeNav() {
  document.getElementById('mySidenav').style.display = 'none';
}

const WrapMenuLi = ({ item, keys, toggleChildCategories }) => (
  <li>
    <Link
      to={{ pathname: `/categories/${item.external_referrer}`, state: { product: { isWrapMenuLi: true, keys, syncProductList: [item.external_referrer, item.locales[process.env.NEXT_PUBLIC_LOCALE].description, item.external_referer] } } }}
      onMouseEnter={() => toggleChildCategories(item.external_referrer)}
      onClick={() => closeMenu()}
    >
      {item.locales[process.env.NEXT_PUBLIC_LOCALE].name}<i className="fas fa-chevron-right" />
    </Link>
  </li>
);

const WrapMenu = ({ parentCategories, toggleChildCategories, childCategories }) => {
  if (parentCategories) {
    const items = parentCategories.map((v, i) => {
      const keys = `category-box-${i}`;
      return <WrapMenuLi item={v} key={`wrapmenuli--${i}`} keys={keys} toggleChildCategories={toggleChildCategories} />;
    });
    const handleDeleteSession = () => {
      sessionStorage.clear();
    };
    return (
      <div className="wrapMenu" onMouseLeave={() => closeMenu()}>
        <ul>{items}</ul>
        <div className="wrapMenuPrincipal" id="wrapMenuPrincipal" onClick={() => handleDeleteSession()}>
          {childCategories}
          <img src={`${ESPOTS}/media/banner-menu.png`} alt="" />
        </div>
      </div>
    );
  }
  return false;
};

const MobileMenu = ({ parentCategories, thirdLevel }) => {
  //console.log(syncProductList);
  if (parentCategories) {
    const items = (parentCategories || []).map((v, i) => {
      const items2 = (thirdLevel || []).map((v2, idx2) => {
        if (v2.locales[process.env.NEXT_PUBLIC_LOCALE].parent_code !== v.external_referrer) return false;
        return <Link key={`subcat-${idx2}`} className="mobileli" to={{ pathname: `/categories/${v2.external_referrer}`, state: { product: { syncProductList: [v2.external_referrer, v2.locales[process.env.NEXT_PUBLIC_LOCALE].description, v2.external_referer] } } }}>{v2.locales[process.env.NEXT_PUBLIC_LOCALE].name}</Link>;
      });
      return (
        <Collapsible key={i} trigger={v.locales[process.env.NEXT_PUBLIC_LOCALE].name.toUpperCase()}>
          {items2}
        </Collapsible>
      );
    });
    return (
      <div id="mySidenav" className="sidenav">
        <a href="#" className="closebtn" onClick={closeNav}>&times;</a>
        <div className="content" />
        {items}
      </div>
    );
  }
  return false;
};

// Component
const Menu = observer((props) => {
  const { navigationStore } = useStores();
  const [parentCategories, setParentCategories] = useState(null);
  const [categories, setCategories] = useState(null);
  const [thirdLevel, setThirdLevel] = useState(null);
  const [childCategories, setChildCategories] = useState(null);

  function getLevelCategories(data, level) {
    const category = [];
    (data.data || []).forEach((v) => {
      if (v.locales[process.env.NEXT_PUBLIC_LOCALE].parent_code !== '') {
        if (v.locales[process.env.NEXT_PUBLIC_LOCALE].categories.length === level) {
          category.push(v);
        }
      }
    });
    console.debug('cat level', level, category);
    return category;
  }

  async function getAllCategories() {
    console.debug('allcategories');
    return navigationStore.getCategories().then((res) => {
      res.data.data.sort((prev, current) => (prev.locales[process.env.NEXT_PUBLIC_LOCALE].position > current.locales[process.env.NEXT_PUBLIC_LOCALE].position ? 1 : -1));
      const data = res.data.data.filter(cat => cat.published);
      const result = { data };
      setCategories(result);
      setParentCategories(getLevelCategories(result, 2));
      setThirdLevel(getLevelCategories(result, 3));
      return result;
    });
  }

  const toggleChildCategories = (parentCode) => {
    const categoriesData = categories.data;
    setChildCategories([]);
    const items = categoriesData.filter(category => category.locales[process.env.NEXT_PUBLIC_LOCALE].parent_code === parentCode).map((filteredCategories, idx) => {
      const items2 = categoriesData.filter(category => category.locales[process.env.NEXT_PUBLIC_LOCALE].parent_code === filteredCategories.external_referrer).map((filteredCategories2, idx2) => (<li key={`subcat--li-${idx2}`}><Link to={{ pathname: `/categories/${filteredCategories2.external_referrer}`, state: { product: { syncProductList: [filteredCategories2.external_referrer, filteredCategories2.locales[process.env.NEXT_PUBLIC_LOCALE].description, filteredCategories2.external_referer] } } }} onClick={closeMenu}>{filteredCategories2.locales[process.env.NEXT_PUBLIC_LOCALE].name}</Link></li>));
      return (<ul key={`subcat-${idx}`}><li key="subcat--li"><Link to={{ pathname: `/categories/${filteredCategories.external_referrer}`, state: { product: { syncProductList: [filteredCategories.external_referrer, filteredCategories.locales[process.env.NEXT_PUBLIC_LOCALE].description, filteredCategories.external_referer] } } }} onClick={closeMenu}>{filteredCategories.locales[process.env.NEXT_PUBLIC_LOCALE].name}</Link></li>{items2}</ul>);
    });
    setChildCategories(items);
  };

  useEffect(() => {
    console.debug('init menu', props);
    getAllCategories();
  }, []);

  return (
    <div className="catalog--module">
      {!isMobile
        ? (
          <div className="nav--categories" onClick={() => openMenu()} onMouseEnter={() => openMenu()}>
            <span />
            <span>&#9776; Todas las categorías</span>
          </div>
        )
        : (
          <div className="menuContainer">
            <MobileMenu parentCategories={parentCategories} thirdLevel={thirdLevel} syncProductList={props.syncProductList} />
            <div className="nav--categories">
              <span style={{ cursor: 'pointer' }} onClick={openNav}>&#9776; Todas las categorias</span>
            </div>
          </div>
        )}
      <div className="nav--search">
        <SearchBox />
      </div>
      <WrapMenu parentCategories={parentCategories} toggleChildCategories={toggleChildCategories} childCategories={childCategories} />
      {props.children}
    </div>
  );
});

export default Menu;
